export enum LayoutEnum {
  PRIMARY_LAYOUT = "PRIMARY_LAYOUT",
  SECONDARY_LAYOUT = "SECONDARY_LAYOUT",
  BLANK_LAYOUT = "BLANK_LAYOUT",
  BLANK_BG_CRIMSON_LAYOUT = "BLANK_BG_CRIMSON_LAYOUT",
}

export enum localStorageKey {
  REGISTER_USER_INFORMATION = "REGISTER_USER_INFORMATION",
  REGISTER_PRESS_RELEASE = "REGISTER_PRESS_RELEASE",
  REGISTER_PREFIX = "REGISTER_PREFIX",
  REGISTER_PROVINCE = "REGISTER_PROVINCE",
  REGISTER_LAST_STEP = "REGISTER_LAST_STEP",
  REGISTER_HISTORY = "REGISTER_HISTORY",
  REGISTER_EDUCATION_LIST = "REGISTER_EDUCATION_LIST",
  REGISTER_NATIONALITY = "REGISTER_NATIONALITY",
  REGISTER_LIST_FOR_COMMITTEE = "REGISTER_LIST_FOR_COMMITTEE",
  REGISTER_CONSENTS = "REGISTER_CONSENTS",
}
